// extracted by mini-css-extract-plugin
export default {"blockDate":"_i7dP_SrdN5BaZdb6Mgt","id":"ezz3YWKjclCGbCM1jttc","reason":"_eErG3ZP_DJ7hugTPotV","error":"XAf_FKvcLACTJ9A75Xnv"};